import { useEffect, useState } from "react";
import {useLocation} from 'react-router-dom';
import { ErrorContext } from "../../../utils/context/error";
import { getArchiveDet, setDelArchiveDet } from "../../../services/archivos";
import Icon from "../../../Icons/general/Icon";
import Iconm from "../../dashboard/menu/icons/Icon";
import FormModal from "./formmodal";
import EditModal from "./editmodal";

function UploadImage() 
{
  const location = useLocation();
  const { setShowToast, setOpciones } = ErrorContext();
  const [ ArchivoId, setArchivoId ] = useState(location.state?.Id);
  const [ ItemId, setItemId ] = useState(0);
  const [tag, setTag] = useState(0);
  const [habilita, setHabilita] = useState(false); 
  const [showM, setShowM] = useState(false);
  const [showE, setShowE] = useState(false);

  const [ Archivos, setArchivo ] = useState([]);
  const [ Detalles, setDetalle ] = useState([]);
  const [videoSeleccionado, setVideoSeleccionado] = useState(null);
  const [videoEditar, setVideoEditar] = useState(null);
  const [eliminando, setEliminando] = useState(false);


//----------------------------------------------------------------------------------------------------------------------
  const fillUploadImagen =async() =>
    {
      setShowToast(false);
      if (ArchivoId >0)
       {
         const response = await getArchiveDet(ArchivoId);
         if (response) 
          {
            if (response.status === 200) 
              {
                setArchivo(response.data.data[0]);
                setDetalle(response.data.detalle);
              } 
            else 
             {
                const Mensaje = response.message;
                const opc = { type: "Danger", message: Mensaje, active: true };
                setOpciones(opc);
                setShowToast(true);
              }
          }
        }
    }
//---------------------------------------------------------------------------------------------------------------------
const fillUpdateImagen =async(data) =>
  {
     setDetalle((prevDetalle) =>
        prevDetalle.map((item) =>
          item.ArchivoId === data.ArchivoId &&
          item.ItemId === data.ItemId
            ? {
                ...item,
                ...data,
              }
            : item
        )
    );
  }
    
//----------------------------------------------------------------------------------------------------------------------
  const handleSubirArchivo = (tagId)=>
    {
      if (tagId === 0) 
       {
         setItemId(0);
       }
       setTag(tagId);
       setShowM(true);
      
    };
  
//----------------------------------------------------------------------------------------------------------------------
  useEffect(() => 
    {
      setShowM(false);
      fillUploadImagen();
    }, []);

//----------------------------------------------------------------------------------------------------------------------
  const GenerarRutaArch = (Datos) => 
    {
      const ItemId = Datos.ItemId;
      const ArchivoId = Datos.ArchivoId;
      const Formato = Datos.Formato;
      const NombreArch = ArchivoId + "_" + ItemId + "." + Formato;
      const RutaArch =  `${import.meta.env.BASE_URL}api/static/${Datos.RutaArch}/${NombreArch}`;
      return RutaArch;
    };
//----------------------------------------------------------------------------------------------------------------------
  const abrirVideo = (ruta) => {
      setVideoSeleccionado(ruta);
  };

  //--------------------------------------------------------------------------------------------------------------------
  const cerrarVideo = () => {
    setVideoSeleccionado(null);
  };    
  
//---------------------------------------------------------------------------------------------------------------------- 
const abrirEditar = (item) => {
  setShowE(true);
  const Ruta = GenerarRutaArch(item);
  setVideoEditar({
    ...item,
    Ruta,
  });
 
};
//----------------------------------------------------------------------------------------------------------------------
const EliminarItem = async(item) => {
  if (ArchivoId >0)
    {
      setEliminando(true);
      //const Ruta = GenerarRutaArch(item);
      const response = await setDelArchiveDet(item.ArchivoId, item.ItemId, 'VI');
      if (response) 
        {
          if (response.status === 200) 
           {
             fillDeleteImagen(response.data.data);               
             setEliminando(false);
           } 
            else 
             {
                setEliminando(false);
                const Mensaje = response.message;
                const opc = { type: "Danger", message: Mensaje, active: true };
                setOpciones(opc);
                setShowToast(true);
              }
        }
    }
};
//----------------------------------------------------------------------------------------------------------------------
const fillDeleteImagen = (archivoEliminado) => {
  setDetalle((detalleAnterior) =>
    detalleAnterior.filter(
      (item) =>
        !(
          Number(item.ArchivoId) ===
            Number(archivoEliminado.ArchivoId) &&
          Number(item.ItemId) ===
            Number(archivoEliminado.ItemId)
        )
    )
  );
};
//----------------------------------------------------------------------------------------------------------------------
  return(
      <>
        <div className="flex flex-col w-full border border-disabled h-[85vh] overflow-y-auto">
            <div className="flex w-full flex-row h-[7rem] border-b border-disabled">
              <div className="flex w-[7rem] h-[7rem] bg-disabled items-center justify-center">
                  <Icon svg="infocircle" className="w-[4rem] h-[4rem] fill-light"></Icon>
              </div>
              <div className="flex flex-col flex-1 w-full items-start justify-center">
                   <div className="flex flex-row w-full space-x-1">
                      <span className="text-right w-[6.8rem] text-gray-700 font-semibold">Carpeta : </span>
                      <span className="text-gray-600">{Archivos?.Carpeta}</span>
                   </div>
                   <div className="flex flex-row w-full space-x-1">
                      <span className="text-right w-[6.8rem] text-gray-700 font-semibold">Area : </span>
                      <span className="text-gray-600">{Archivos?.NombreArea}</span>
                   </div>
                   <div className="flex flex-row w-full space-x-1">
                      <span className="text-right w-[6.8rem] text-gray-700 font-semibold">Descripción : </span>
                      <span className="text-gray-600">{Archivos?.Descripcion}</span>
                   </div>
              </div>
              <div className="flex w-[14rem] h-full items-center justify-center">
                <button name="Aceptar" type="button" className="flex flex-row w-[12.5rem] h-[4rem] items-center justify-center gap-2 btnprimary" 
                        onClick={() => handleSubirArchivo(0)} disabled={habilita} ><Icon svg="plusl" className="w-[1.2rem] h-[1.2rem] fill-light"></Icon>Agregar</button>
              </div>
            </div>
            <div className="flex flex-row w-full flex-wrap gap-x-3 gap-y-3 p-4">
               {
                 Detalles.map((item) => {
                   const Ruta = GenerarRutaArch(item);
                 return <div className="flex flex-col w-[16rem] h-[10rem] border border-stone-200"
                           key={`${item.ArchivoId}${item.ItemId}`}
                           //onClick={() => history.push(`/images/${image._id}`)}
                        >
                       <div className="flex h-[80%] border-none" key={`$cardw{item.ArchivoId}${item.ItemId}`}>
                         <video
                           src={Ruta}
                           alt=""
                           className="flex w-full h-full aspect-video border-none"
                           
                           key={`img${item.ArchivoId}${item.ItemId}`}
                         />
                       </div>
                        <div className="flex flex-row gap-2 justify-end mr-2 pt-2">
                                <button
                                  type="button"
                                  onClick={() => abrirVideo(Ruta)}
                                  title="Ver video"
                                  className="nobutton"
                                >
                                  <Iconm
                                    svg="eye"
                                    className="w-[1.2rem] h-[1.2rem] fill-disabled"
                                  />
                                </button>

                                <button
                                  type="button"
                                  title="Editar"
                                  className="nobutton"
                                  onClick={() => abrirEditar(item)}
                                >
                                  <Iconm
                                    svg="pencil"
                                    className="w-[1.2rem] h-[1.2rem] fill-disabled"
                                  />
                                </button>

                                <button
                                  type="button"
                                  title="Eliminar"
                                  className="nobutton"
                                  onClick={() => EliminarItem(item)}
                                >
                                  <Iconm
                                    svg="delfile"
                                    className="w-[1.2rem] h-[1.2rem] fill-disabled"
                                  />
                                </button>
                          </div>
                    </div>
                 })}
             </div>
        </div>
        <FormModal
              show={showM}
              ArchivoI={ArchivoId}
              Tag={tag}
              handleshow={setShowM}
              fillUploadImagen={fillUploadImagen}
        ></FormModal>
      {showE && (
        <EditModal
              show={showE}
              ArchivoI={ArchivoId}
              Tag={tag}
              handleshow={setShowE}
              videoEditar={videoEditar}
              fillUploadImagen={fillUpdateImagen}
        ></EditModal>
      )}
      {videoSeleccionado && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
            onClick={cerrarVideo}
          >
            <div
              className="relative w-full max-w-4xl rounded-lg bg-black p-3"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button nobutton"
                onClick={cerrarVideo}
                className="absolute right-3 top-3 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-white text-xl text-black"
              >
                ×
              </button>

              <video
                key={videoSeleccionado}
                src={videoSeleccionado}
                controls
                autoPlay
                className="max-h-[80vh] w-full rounded object-contain"
              >
                Tu navegador no soporta la reproducción de video.
              </video>
            </div>
          </div>
        )} 

        {eliminando && (
          <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 shadow-lg text-center">
              <div className="animate-spin h-8 w-8 border-4 border-gray-300 border-t-blue-600 rounded-full mx-auto mb-4"></div>
              <p className="text-gray-700 font-medium">Consultando usuarios...</p>
              <p className="text-sm text-gray-500">Por favor espere</p>
            </div>
          </div>
       )}
    

    </>);
}
export default UploadImage;